import { observer } from 'mobx-react'
import React, { ReactElement } from 'react'

import {
   isLoggedIn,
   LoginController
} from '@flowwai-frontend/bps-officer-web/login'
import { Redirect } from 'react-router-dom'
import { HOME_ROUTE_PATH } from '@flowwai-frontend/bps-officer-web/common/data-access'

const LoginRoute = (): ReactElement => {
   const redirectToHomePage = () => <Redirect to={HOME_ROUTE_PATH} />

   return isLoggedIn() ? redirectToHomePage() : <LoginController />
}

export default observer(LoginRoute)
